import { useEffect, useState } from "react";
import { Button, Modal } from "semantic-ui-react";
import { FormError } from "../models/FormError";
import { Organization } from "../models/Organization";
import { PermitBlueprint } from "../models/PermitBlueprint";
import AddBlueprintToOrganizationForm, { AddBlueprintToOrgFormData } from "./AddBlueprintToOrganizationForm";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (blueprintId: string, organizationId: string, permitTypeName?: string) => void;
  submitInProgress: boolean;
  submitErrors?: string[];
  blueprint?: PermitBlueprint;
  organizations?: Organization[];
}

const AddBlueprintToOrganizationModal = ({
  open,
  onClose,
  onSubmit,
  submitInProgress,
  submitErrors,
  blueprint,
  organizations,
}: Props) => {
  const [formData, setFormData] = useState<AddBlueprintToOrgFormData>({} as AddBlueprintToOrgFormData);
  const [formErrors, setFormErrors] = useState<FormError>({});

  useEffect(() => {
    if (!open) {
      setFormData({} as AddBlueprintToOrgFormData);
      setFormErrors({});
    }
  }, [open]);

  const validate = (data: AddBlueprintToOrgFormData): FormError => {
    const errors: FormError = {};
    if (!data.organizationId) errors.organizationId = "Please select an organization";
    return errors;
  };

  const handleSubmit = () => {
    const errors = validate(formData);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0 && blueprint) {
      onSubmit(blueprint.id, formData.organizationId, formData.permitTypeName || undefined);
    }
  };

  return (
    <Modal open={open} onClose={onClose} size="small">
      <Modal.Header>Add &quot;{blueprint?.name}&quot; to Organization</Modal.Header>
      <Modal.Content>
        <AddBlueprintToOrganizationForm
          formData={formData}
          formErrors={formErrors}
          errors={submitErrors}
          organizations={organizations}
          onChange={setFormData}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} disabled={submitInProgress}>
          Cancel
        </Button>
        <Button primary onClick={handleSubmit} loading={submitInProgress} disabled={submitInProgress}>
          Add
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default AddBlueprintToOrganizationModal;

